<div>
  <div class="txt-ola">Olá,</div>
  <div class="txt-nome">{{ firstName }}!</div>

  @if (modelLocator.menu.classificacao) {
    <ion-row class="area-badge">
      <ion-col>
        @if (modelLocator.dadosLogin.classificacao) {
          <img [src]="modelLocator.dadosLogin.classificacao_imagem" />
        }

        <!-- <ion-label class="title-classification">{{ modelLocator.dadosLogin.classificacao }}</ion-label>\ -->
      </ion-col>
    </ion-row>
  }

  @if (modelLocator.menu.pontuacao) {
    <div class="box-pontos">
      <span class="tit">T-COINS</span>
      <span class="pontos_usuario pt">{{ modelLocator.saldo.tcoins_saldo ? modelLocator.saldo.tcoins_saldo : 0 }}</span>
      @if (modelLocator.pts_expirar !== 0) {
        <span class="tit-expirar">A EXPIRAR:</span>
        <span class="pontos_usuario pt">{{ modelLocator.pts_expirar }}</span>
      }
    </div>
  }

  @if (showTickets) {
    <ion-row class="ion-justify-content-center">
      <div class="box-tickets desktop">
        <span class="pontos_usuario pt">{{ modelLocator.saldo.ticket_saldo ? modelLocator.saldo.ticket_saldo : 0 }}</span>
        <img src="../assets/image/ticket_menu.png" alt="" />
      </div>
    </ion-row>
  }

  <div class="traco-perfil"></div>

  <div class="menu-perfil">
    @for (item of profileMenu; track item.route) {
      @if (getCondition(item)) {
        <a (click)="touchGoToRoute(item.route)">
          {{ item.label }}
          <br />
        </a>
      }
    }
  </div>

  <div class="traco-perfil"></div>

  <div class="box-central-ajuda" (click)="touchGoToRoute('/help')">
    <a>
      <img src="../../../assets/icon/icone_central_ajuda.svg" alt="Central de Ajuda" />
    </a>
    <div>
      <a><span class="txt-cinza-escuro-12">CENTRAL</span></a>
      <br />
      <a><span class="txt-cinza-escuro-12">DE AJUDA</span></a>
    </div>
  </div>

  <div class="box-central-ajuda box-faq" (click)="touchGoToRoute('/faq')">
    <!-- <ion-col> -->
    <img src="../../../assets/icon/faq.svg" alt="Central de Ajuda" />
    <!-- </ion-col> -->
  </div>
</div>
